// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"18460":"20d6bb02fec47021","84455":"16ef54310ad254c5","94535":"e6a3d1cf66f0ddf4"}[chunkId] + ".css";
};